import client from './client';
import { API } from '../config/routes';

export const createRooms = (songLimit, qrCount, spotifyAccountId) =>
  client.post(API.ROOMS.BASE, { songLimit, qrCount, spotifyAccountId }).then((r) => r.data.data);

export const scanQR = (token, deviceId) =>
  client.get(API.ROOMS.SCAN, { params: { token, deviceId } }).then((r) => r.data.data);
